export const vatCodeMutationFrag = `
    id
`;
